import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createHeroApi, storeHeroApi } from './heroSlice';
import isEmpty from 'lodash/isEmpty';
import { RequestBodyConverter } from '../RequestBodyConverter';
import HeroForm from './HeroForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';

function HeroCreate() {
    const [resetCount, setResetCount] = useState(0);
    const { model: initialValues, pictureAttributeNames } = useSelector((state) => state.heroSaga.hero);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        rawValues.rankId = 'RNK001';
        let values = new RequestBodyConverter(rawValues);
        await values.convertPictures(rawValues, pictureAttributeNames);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.

        dispatch(storeHeroApi({ navigate, values }));
    };

    useEffect(() => {
        if (isEmpty(initialValues)) {
            dispatch(createHeroApi());
        }
    }, []);

    return (
        <HeroForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default HeroCreate;
